/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleQueryRecurrence extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ScheduleQueryRecurrence");
    }

    getFixupPrototypeFunction() { return ScheduleQueryRecurrence.fixupPrototype; }

    static newInstance(model: Partial<ScheduleQueryRecurrence>): ScheduleQueryRecurrence {
        let obj = Object.assign(new ScheduleQueryRecurrence(), model);
        ScheduleQueryRecurrence.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleQueryRecurrence>): ScheduleQueryRecurrence {
        if (!model) return null;
        return ScheduleQueryRecurrence.newInstance(<ScheduleQueryRecurrence> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleQueryRecurrence) {
        if (!obj) return;

        models.ScheduleQueryRecurrence.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleQueryRecurrence): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleQueryRecurrence.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Recurrence of the Schedule
     */
    recurrences: Array<models.ScheduleRecurrence>;

}
